import styled from 'styled-components';
import ArrowCTAIcon from './ArrowCTAIcon';

const StyledArrowIcon = styled(ArrowCTAIcon)`
  transform: rotate(90deg);
  width: 25px;
`;

/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const ArrowDownIcon = ({ className }) => (
  <StyledArrowIcon className={className} />
);

export default ArrowDownIcon;
